"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OTHER_CATALOGUES_SKELETON = exports.OTHER_CATALOGUES = exports.COUNT_OF_CATALOGUE_SKELETONS = void 0;
const OTHER_CATALOGUES = exports.OTHER_CATALOGUES = 'other-catalogues';
const OTHER_CATALOGUES_SKELETON = exports.OTHER_CATALOGUES_SKELETON = 'other-catalogues-skeleton';
const COUNT_OF_CATALOGUE_SKELETONS = exports.COUNT_OF_CATALOGUE_SKELETONS = 10;
